<div class="widget-content-container termine-widget">
  <div slimScroll [scrollEvents]="slimScrollEvents" class="scroll-space h-100">
    @if (termineLoading) {
      <div><iq-loading-indicator></iq-loading-indicator></div>
    }
    @if (errMessage && !termineLoading) {
      <div>
        <h4>{{ errMessage | translate }}</h4>
      </div>
    }
    @if (!termineLoading) {
      <div>
        @if (termine.length === 0) {
          <p class="text-center">{{ 'KEINE_DATENSAETZE_VORHANDEN' | translate }}</p>
        }
        @if (termine.length > 0) {
          <div class="table-container table-responsive">
            <table class="table table-hover">
              <tbody>
                @for (termin of termine; track termin) {
                  <tr #terminRow class="no-inline-border" [class.abgelaufen]="termin.Abgelaufen">
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm m-0 p-0 expand-button"
                        (click)="termin.expanded = !termin.expanded"
                      >
                        <span
                          class="fa"
                          [class.fa-angle-down]="termin.expanded"
                          [class.fa-angle-right]="!termin.expanded"
                        >
                        </span>
                      </button>
                    </td>
                    <td>
                      <div class="text-bold">
                        <span> {{ termin.GueltigVon | date: FORMAT.DATE }} </span>
                        @if (termin.GueltigVon !== termin.GueltigBis) {
                          <span> - {{ termin.GueltigBis | date: FORMAT.DATE }} </span>
                        }
                      </div>
                      <div class="text-muted">{{ termin.Ueberschrift }}</div>
                    </td>
                    <td></td>
                  </tr>
                  @if (termin.expanded) {
                    <tr class="hide-tr-hover">
                      <td colspan="2">{{ termin.Text }}</td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- widget bearbeiten -->
<div class="widget-bearbeiten-container disabled"></div>
